import { cookieExists, createCookie, deleteCookie, lockScroll, unlockScroll } from '../util/common';
import { newModalFromString } from '../components/modal';
import { popupPrivacyPolicyListener } from '../privacyPolicyPopup';

class NewsletterPopup {
    init () {
        var url = new URL(window.location.href);
        var showPopup = url.searchParams.get('showNewsletter');
        if ((!cookieExists('dw_subscribepopup') && window.SitePreferences.NewsletterPopupEnabled) || (showPopup)) {
            setTimeout(function () {
                showNewsletterPopup();
            }, showPopup ? 0 : window.SitePreferences.NewsletterPopupDelay);
        }
        this.firstVisitNewsletterPopUp();
        popupPrivacyPolicyListener();
    }

    setCookie () {
        createCookie('dw_subscribepopup', '1', parseInt(window.SitePreferences.NewsletterPopupExpiryDays));
    }

    showPopup () {
        showNewsletterPopup();
    }

    firstVisitNewsletterPopUp () {
        if (cookieExists('cookies-accepted') && $('.js-page-home-gender').length > 0) {
            setTimeout(function () {
                showNewsletterPopup();
                deleteCookie('cookies-accepted');
            }, window.SitePreferences.NewsletterPopupDelay);
        }
    }
}

function showNewsletterPopup () {
    const url = window.Urls.getNewsletterPopup;
    const onPopupClose = () => {
        unlockScroll();
        createCookie('dw_subscribepopup', '1', parseInt(window.SitePreferences.NewsletterPopupExpiryDays));
    };

    if (url) {
        $.ajax({
            url: url,
            type: 'get',
            success: function (data) {
                const modal = newModalFromString(data, false, ['newsletter-popup'], null, onPopupClose);
                $('#newspromotions_targeted').attr('disabled', true);
                $('#newspromotions_targeted1').attr('disabled', true);
                // $('#checkbox-label-yes').css('color', '#E8E8E8');
                // $('#checkbox-label-no').css('color', '#E8E8E8');
                $('#grayOnDisableDescription').css('color', '#E8E8E8');


                modal.open();

                $('#linkToBeRendered').html($('#formattedLink').text());

                if (!Foundation.MediaQuery.atLeast('large')) {
                    lockScroll();
                }

                $(modal.modalBox)
                    .find('.close')
                    .on('click', function (e) {
                        modal.close();
                    });

                $(modal.modalBox)
                    .find('.js-noThanks')
                    .on('click', function (e) {
                        modal.close();
                    });

                $(modal.modalBox)
                    .find('.js-subscribe-close')
                    .on('click', function (e) {
                        modal.close();
                    });

                newsletterPopupControl();

                // Since the form is loaded asynchronously, launch Parsley validation on success
                $('body').trigger('newsletter:showPopup', { form: $(modal.modalBox).find('form') });
                $(modal.modalBox).find('form')
                    .parsley({
                        errorClass: 'is-invalid-input',
                        successClass: 'is-valid-input',
                        errorsWrapper: '<div class="errors-list"></div>',
                        errorTemplate: '<span class="form-error is-visible"></span>'
                    }).on('field:error', e => {
                        if (e.$element.closest('.input-error-group').hasClass('error-outside')) {
                            const elementName = e.$element.attr('name');
                            const error = e.$element.parents('label').next('.errors-list');
                            const $errorLocation = e.$element.closest('form').find(`[data-parsley-error-binding="${elementName}"]`);
                            error.appendTo($errorLocation);
                        }
                    });

            },
            error: function (err) {
                console.log(err);
            }
        });
    }
}

function newsletterPopupControl () {
    const newsletterEmail = $('#email');
    const imagePopUp = $('.js-imgPopup');
    const newsletterTitle = $('.js-newsletterFormTitle');
    const proceedStepZeroMobile = $('.js-proceedStepZeroMobile');
    const proceedStepZeroDesktop = $('.js-proceedStepZeroDesktop');
    const stepZero = $('.js-stepZero');
    const newsletterGender = $('#newsletterGender');
    const stepOnePointOne = $('.js-stepOnePointOne');
    const proceedStepOnePointOne = $('.js-proceedStepOnePointOne');
    const stepOnePointTwo = $('.js-stepOnePointTwo');
    const proceedStepOnePointTwo = $('.js-proceedStepOnePointTwo');
    const newsletterEmailVal = $('#newsletter-Email').val();
    const newsletterEmailValContacts = $('#newsletter-Email-contacts').val();
    const newsletterStep = $('.registerNewsletter');
    const confirmSubscription = $('.js-subscriptionSuccess');
    const checkPromotionOne = $('#newspromotions_targeted');
    const checkPromotionTwo = $('#newspromotions_targeted1');
    const backStepOnePointOne = $('.js-backStepOnePointOne');

    if (($('#newsletterFooterForm').data('which-form') === 'newsletter' && newsletterEmailVal !== '') || ($('#newsletterFooterForm').data('which-form') === 'newsletter-contacts' && newsletterEmailValContacts !== '')) {
        if (newsletterEmailVal !== '') {
            newsletterEmail.val(newsletterEmailVal);
        } else {
            newsletterEmail.val(newsletterEmailValContacts);
        }

        imagePopUp.addClass('hidden');
        newsletterTitle.addClass('hidden');
        stepZero.addClass('hidden');
        stepOnePointOne.removeClass('hidden');
        // We need to separate the step-one-point-one from direct/indirect email input in footer
        $('.js-newslettersNavigationButtons').removeClass('cc-popupNavigationButtons');
        $('.js-newslettersNavigationButtons').addClass('cc-directEmailButtons');
        $('.js-proceedStepOnePointOne').addClass('js-directEmailProceed cc-directEmailProceed');
        $('.js-directEmailProceed').on('click', function (e) {
            $('.js-stepOnePointTwo').addClass('js-directFromStepOnePointOne');
        });
        newsletterStep.data('stage', 'js-stepOnePointOne');

        backStepOnePointOne.addClass('hidden');
        $('.js-noThanksDirectOpen').removeClass('hidden');
        $('.js-notDirectOpen').addClass('hidden');
        $('.js-directOpenDesktop').removeClass('hidden');
        $('.js-directOpenMobile').removeClass('hidden');

        if (Foundation.MediaQuery.atLeast('medium')) {
            stepOnePointTwo.removeClass('hidden');
        }
    }

    newsletterEmail.on('input', function (e) {
        if (newsletterEmail.parsley().isValid()) {
            $('#email[name=newsletterEmail]').attr('aria-invalid', 'false');
            $('#email-errors').addClass('hide-error');
            $('#email').removeClass('error-border');
        } else {
            $('#email[name=newsletterEmail]').attr('aria-invalid', 'true');
            $('#email-errors').removeClass('hide-error');
            $('#email').addClass('error-border');
        }
    });

    $(window).on('resize', function (e) {
        if (confirmSubscription.hasClass('hidden') && stepZero.hasClass('hidden')) {
            if (Foundation.MediaQuery.atLeast('medium')) {
                stepOnePointOne.removeClass('hidden');
                stepOnePointTwo.removeClass('hidden');
            } else {
                if (newsletterStep.data('stage') === 'js-stepOnePointOne') {
                    stepOnePointOne.removeClass('hidden');
                    stepOnePointTwo.addClass('hidden');
                } else if (newsletterStep.data('stage') === 'js-stepOnePointTwo') {
                    stepOnePointOne.addClass('hidden');
                    stepOnePointTwo.removeClass('hidden');
                }
            }
        }
    });

    proceedStepZeroMobile.on('click', function (e) {
        proceedStepZeroMobile.trigger('blur');
        if (!newsletterEmail.parsley().isValid()) {
            $('#email-errors').removeClass('hide-error');
            $('#email').addClass('error-border');
            return;
        }
        $('#email-errors').addClass('hide-error');
        $('#email').removeClass('error-border');
        imagePopUp.addClass('hidden');
        newsletterTitle.addClass('hidden');
        stepZero.addClass('hidden');
        stepOnePointOne.removeClass('hidden');
        // Add new class to create different dimensions for the modal
        newsletterStep.closest('.tingle-modal-box').addClass('cc-stepOnePointOne');
        newsletterStep.data('stage', 'js-stepOnePointOne');
    });

    proceedStepZeroDesktop.on('click', function (e) {
        proceedStepZeroDesktop.trigger('blur');
        if (!proceedStepZeroDesktop.hasClass('disabled')) {
            if (!newsletterEmail.parsley().isValid()) {
                $('#email-errors').removeClass('hide-error');
                $('#email').addClass('error-border');
                return;
            }
            $('#email-errors').addClass('hide-error');
            $('#email').removeClass('error-border');
            imagePopUp.addClass('hidden');
            newsletterTitle.addClass('hidden');
            stepZero.addClass('hidden');
            stepOnePointOne.removeClass('hidden');
            stepOnePointTwo.removeClass('hidden');
            newsletterStep.data('stage', 'js-stepOnePointOne');
        }
    });

    $('#newsletterCountry').on('input', function (e) {
        newsletterStep.data('stage', 'js-stepOnePointOne');
    });

    newsletterGender.on('input', function (e) {
        newsletterStep.data('stage', 'js-stepOnePointOne');
        if (newsletterGender.val()) {
            proceedStepOnePointOne.removeClass('disabled');
            if (checkPromotionOne[0].checked || checkPromotionTwo[0].checked) {
                proceedStepOnePointTwo.removeClass('disabled');
            }
        }
    });

    backStepOnePointOne.on('click', function (e) {
        stepOnePointOne.addClass('hidden');
        imagePopUp.removeClass('hidden');
        newsletterTitle.removeClass('hidden');
        stepZero.removeClass('hidden');
        // Remove the class to show the direct step-one-point-one dimensions if user go back
        newsletterStep.closest('.tingle-modal-box').removeClass('cc-stepOnePointOne');
    });

    proceedStepOnePointOne.on('click', function (e) {
        proceedStepOnePointOne.trigger('blur');
        if (!proceedStepOnePointOne.hasClass('disabled')) {
            stepOnePointOne.addClass('hidden');
            stepOnePointTwo.removeClass('hidden');
            // Remove the class to appear the regular dimensions for the rest of the flow
            newsletterStep.closest('.tingle-modal-box').removeClass('cc-stepOnePointOne');
            newsletterStep.data('stage', 'js-stepOnePointTwo');
        }
    });

    $('#newspromotions').on('click', function (e) {
        newsletterStep.data('stage', 'js-stepOnePointTwo');
    });

    $('#newspromotions1').on('click', function (e) {
        proceedStepOnePointTwo.addClass('disabled');
        newsletterStep.data('stage', 'js-stepOnePointTwo');
    });

    checkPromotionOne.on('click', function (e) {
        if (newsletterGender.val()) {
            proceedStepOnePointTwo.removeClass('disabled');
            newsletterStep.data('stage', 'js-stepOnePointTwo');
        }
    });

    checkPromotionTwo.on('click', function (e) {
        if (newsletterGender.val()) {
            proceedStepOnePointTwo.removeClass('disabled');
            newsletterStep.data('stage', 'js-stepOnePointTwo');
        }
    });

    $('.js-backStepOnePointTwo').on('click', function (e) {
        stepOnePointTwo.addClass('hidden');
        stepOnePointOne.removeClass('hidden');
        // Check if the step-one-point-two hasn't this class so it will appear the indirect email modal dimensions on back button
        if (!$('.js-stepOnePointTwo').hasClass('js-directFromStepOnePointOne')) {
            newsletterStep.closest('.tingle-modal-box').addClass('cc-stepOnePointOne');
        }
        newsletterStep.data('stage', 'js-stepOnePointOne');
    });

    proceedStepOnePointTwo.on('click', function (e) {
        $('body').trigger('newsletter:stepOnePointTwo', { title: newsletterGender.find('option:selected').val() });
        proceedStepOnePointTwo.trigger('blur');
        if (!proceedStepOnePointTwo.hasClass('disabled')) {
            $.spinner().start();
            $.ajax({
                url: newsletterStep.attr('action'),
                type: 'post',
                dataType: 'json',
                data: newsletterStep.serialize(),
                success: function (data) {
                    $.spinner().stop();
                    if (data.alreadySubscribed) {
                        $('#linksToBeRendered').html($('#formattedLinks').text());
                        $('.registrationFormStepOne').addClass('hidden');
                        $('.registrationFormStepTwo').removeClass('hidden');
                        $('.written-email').text(data.registeredEmail);
                    }
                    else {
                        stepOnePointOne.addClass('hidden');
                        stepOnePointTwo.addClass('hidden');
                        confirmSubscription.removeClass('hidden');
                        newsletterStep.closest('.tingle-modal-box').addClass('cc-confirmSubscriptionModal');
                    } 
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

const newsletterPopup = new NewsletterPopup();
export default newsletterPopup;
